export default {
  login: {
    logIn: '立即登录 Sign-In',
    bind: '绑定',
    enterSystem: '进入系统',
    username: '账号名 Account',
    password: '密码 Password',
    any: '随便填',
    accountTit: '账号密码登录',
    useAccountLogin: '使用账号密码登录',
    ForgotPassword: '忘记密码',
    inputTel: '手机号 Tel',
    inputMail: '邮箱 E-mail',
    telOrMail: '手机号/邮箱 Tel/E-mail',
    telOrMailOrAccount: '手机号/邮箱/账号 Tel/E-mail/Account',
    codeTit: '验证码登录',
    code: '验证码 Verification code',
    useCodeLogin: '使用验证码登录',
    getNoCode: '没收到验证码？',
    scanTit: '微信扫码登录',
    account: '账号名 Account',
    newPassword: '新密码 New password',
    confirmPassword: '确认新密码 Confirm password',
    confirm: '确定 Confirm'
  },
  table: {
    noData: 'no data'
  },
  common: {
    selectSource: 'Select Source',
    selectMonth: 'Select Month'
  },
  onlineReport: {
    onlineReport: 'Online report',
    projectReport: 'Project report',
    publicReport: 'Public report',
    planReport: 'Proposal',
    topicReport: 'Topic report',
    conditions: 'Conditions',
    reportName: 'Report name',
    reportType: 'Report type',
    reportLabel: 'Report label',
    reportForm: 'Report form',
    reportFrequency: 'Report frequency',
    reportMode: 'Report mode',
    reportSequence: 'Report sequence',
    releasedTime: 'Released time',
    reportIntroduction: 'Report introduction',
    reportPeriod: 'Report period',
    confirm: 'Confirm',
    reset: 'Reset',
    to: 'to',
    all: 'All',
    chooseReportType: 'Choose report type',
    choosePeriod: 'Choose period',
    selected: 'Selected',
    reportTypeSubType: 'Please input report type or sub-type',
    search: 'Search',
    top: 'Top',
    publisher: 'Publisher',
    reportSize: 'Report size',
    scanTheReport: 'Scan the report',
    download: 'Download',
    freeForLimitedTime: 'Free for a limited time',
    left: 'left',
    day: 'day',
    hour: 'hour',
    second: 'second',
    saySth: 'Say sth…',
    endOfPreview: 'End of preview',
    tipPagesNotRead: 'pages not read. If you want to get more information or buy this report, Please contact 020-83912326',
    like: 'Like',
    comment: 'Comment',
    send: 'Send',
    commentSucceded: 'Comment succeded. Thank you.',
    select: 'Select',
    enterKeywordsSearch: 'Please enter keywords to search',
    startingTime: 'Starting time',
    endTime: 'End Time',
    contactToBuy: 'Contact to buy',
    makePurchase: 'Please contact Wilson 020-83912326 to make a purchase, you can view after purchase',
    pleaseWait: 'Please wait, downloading ...',
    tipoperationFailed: 'Operation failed, please contact the developer!',
    tipNotSupportBrowsing: 'The report does not support browsing, please check it by purchasing and downloading!',
    noData: 'No Data',
    applyForAuthorization: 'Apply for authorization',
    forMoreInformation: 'This report needs to apply for authorization. For more information, please contact Wilson 020-83912326',
    totalItems: 'Total {count} items',
    previous: 'Previous',
    next: 'Next',
    freeLimitedTime: 'Free for a limited time',
    default: 'Default',
    informationOverview: 'Information overview'
  },
  home: {
    welcome: 'Welcome to i-Analytics decision-making support system',
    portal: 'Portal',
    broadOverview: 'Broad Overview',
    onlineReport: 'Online Report',
    IWminiProgram: 'IW mini program',
    enterNew: 'Enter the new',
    officialWebsite: 'Official website',
    enterSystem: 'Enter System',
    frequentlyUsed: 'Frequently Used',
    announcement: 'Announcement',
    basicInformation: 'Basic information',
    feedbackResponse: 'Feedback response',
    changePassword: 'Change password',
    logOut: 'Log Out',
    switchAccount: 'Switch account',
    informationOverview: 'Information overview',
    solutions1: 'Market monitoring',
    solutions11: 'Market overview',
    solutions12: 'Product position inspection',
    solutions2: 'Competitiveness analysis',
    solutions21: 'Product competitiveness',
    solutions22: 'Price competitiveness',
    solutions23: 'Propagation competitiveness',
    solutions24: 'Brand competitiveness',
    solutions25: 'Channel competitiveness',
    solutions3: 'Adjustment & Optimization',
    solutions31: 'Equipment optimization strategy',
    solutions32: 'Pricing strategy',
    solutions4: 'Sales opportunity management',
    solutions41: 'User portrait marketing',
    solutions42: 'Sales clue rating',
    solutions5: 'User loyalty management',
    solutions51: 'Financial service',
    solutions52: 'Claim service',
    solutions53: 'Maintenance service',
    solutions54: 'IOV service',
    solutions6: 'Customer relationship management',
    solutions61: 'Car owner management',
    solutions62: 'Purchase recommendation',
    solutions7: 'Headquarter-region-dealership operation & management',
    solutions71: 'Sale',
    solutions72: 'Value chain',
    solutions73: 'After-sale',
    // no english',
    doesNotSupport: 'Your browser does not support the video tag.',
    returnPortal: 'Back to portal',
    IKnow: 'Got it',
    scanIWminiProgram: 'Scan QR code to IW mini program',
    accountStatus1: 'Disabled',
    accountStatus2: 'Enabled',
    accountStatus3: 'Frozen',
    accountType1: 'Official account',
    accountType2: 'Trial account',
    accountType3: 'Internal account',
    accountType4: 'Test account',
    columns1: 'Institution',
    columns2: 'Account',
    columns3: 'Name',
    columns4: 'Account type',
    columns5: 'Status',
    columns6: 'Valid to',
    switchToAccount: 'Change account（{name}）',
    perfectYourPersonalLetter: 'Basic information of new users, <br>please fill in personal information<br>',
    pullDownToSwitchAccounts: 'Pull to change account',
    switchLanguageSuccess: 'Language changed',
    switchLanguageFail: 'Language change failed',
    details: 'Details',
    statusName1: 'Enter',
    statusName2: 'Coming soon',
    statusName3: 'Apply for test',
    statusName4: 'Unavailable',
    foot1: 'Home page / i-Analytics / i-Solutions / DaaS / Join us',
    foot2: 'Guangzhou WAYS Information Technology Co., Ltd.'

  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js